var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-print';
                    var viewUrl = 'sprite.svg#view-icon-print';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-print#icon-print';
                            viewUrl = 'sprite.svg?icon-print#view-icon-print';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 15',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };